import { render, staticRenderFns } from "./CRDropdown.vue?vue&type=template&id=0efd9548&scoped=true"
import script from "./CRDropdown.vue?vue&type=script&lang=js"
export * from "./CRDropdown.vue?vue&type=script&lang=js"
import style0 from "./CRDropdown.vue?vue&type=style&index=0&id=0efd9548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efd9548",
  null
  
)

export default component.exports